(function () {
  'use strict';

  var DEFAULT_CENTER = { lat: 45.5017, lng: -73.5673 };
  var DEFAULT_ZOOM = 8;
  var SEARCH_RADIUS_KM = 100;
  var NEAREST_FALLBACK_COUNT = 3;

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function haversineDistance(origin, destination) {
    var earthRadiusKm = 6371;
    var toRadians = function (degrees) {
      return degrees * Math.PI / 180;
    };
    var latitudeDelta = toRadians(destination.lat - origin.lat);
    var longitudeDelta = toRadians(destination.lng - origin.lng);
    var originLatitude = toRadians(origin.lat);
    var destinationLatitude = toRadians(destination.lat);
    var a =
      Math.sin(latitudeDelta / 2) * Math.sin(latitudeDelta / 2) +
      Math.cos(originLatitude) *
        Math.cos(destinationLatitude) *
        Math.sin(longitudeDelta / 2) *
        Math.sin(longitudeDelta / 2);
    return earthRadiusKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function waitForGoogleMaps(onReady, onUnavailable) {
    var attempts = 0;
    var maximumAttempts = 30;

    function check() {
      if (window.google && window.google.maps && window.google.maps.Map) {
        onReady();
        return;
      }

      attempts += 1;
      if (attempts >= maximumAttempts) {
        onUnavailable();
        return;
      }

      window.setTimeout(check, 150);
    }

    check();
  }

  function createInfoContent(store, labels) {
    var content = document.createElement('div');
    content.className = 'StoreMapInfo';

    var title = document.createElement('h3');
    title.className = 'StoreMapInfo__Title';
    title.textContent = store.name;
    content.appendChild(title);

    var address = document.createElement('p');
    address.className = 'StoreMapInfo__Address';
    address.textContent = store.address;
    content.appendChild(address);

    var links = document.createElement('div');
    links.className = 'StoreMapInfo__Links';

    var storeLink = document.createElement('a');
    storeLink.href = store.url;
    storeLink.textContent = labels.viewStore;
    links.appendChild(storeLink);

    var directionsLink = document.createElement('a');
    directionsLink.href = store.directionsUrl;
    directionsLink.target = '_blank';
    directionsLink.rel = 'noopener';
    directionsLink.textContent = labels.directions;
    links.appendChild(directionsLink);

    content.appendChild(links);
    return content;
  }

  function initStoreLocator(root) {
    var form = root.querySelector('[data-store-search]');
    var input = root.querySelector('[data-store-search-input]');
    var submitButton = root.querySelector('[data-store-search-submit]');
    var locationButton = root.querySelector('[data-store-use-location]');
    var clearButton = root.querySelector('[data-store-clear]');
    var list = root.querySelector('[data-store-results]');
    var mapElement = root.querySelector('[data-store-map]');
    var mapMessage = root.querySelector('[data-store-map-message]');
    var status = root.querySelector('[data-store-status]');
    var cardElements = Array.prototype.slice.call(root.querySelectorAll('[data-store-card]'));
    var labels = {
      allLocations: root.dataset.allLocations,
      resultOne: root.dataset.resultOne,
      resultMany: root.dataset.resultMany,
      viewStore: root.dataset.viewStore,
      directions: root.dataset.directions,
      mapUnavailable: root.dataset.mapUnavailable,
      locationError: root.dataset.locationError,
      searchError: root.dataset.searchError,
      nearestFallback: root.dataset.nearestFallback,
      distanceLabel: root.dataset.distanceLabel,
      yourLocation: root.dataset.yourLocation
    };
    var stores = cardElements.map(function (element, index) {
      return {
        element: element,
        index: index,
        name: element.dataset.storeName,
        address: element.dataset.storeAddress,
        url: element.dataset.storeUrl,
        directionsUrl: element.dataset.directionsUrl,
        searchText: normalizeText(element.dataset.searchText),
        lat: Number(element.dataset.latitude),
        lng: Number(element.dataset.longitude),
        distance: null,
        distanceElement: element.querySelector('[data-store-distance]'),
        marker: null
      };
    }).filter(function (store) {
      return Number.isFinite(store.lat) && Number.isFinite(store.lng);
    });

    var map = null;
    var infoWindow = null;
    var autocomplete = null;
    var autocompleteService = null;
    var placesService = null;
    var originMarker = null;
    var resolvedInputValue = '';

    function setStatus(message) {
      status.textContent = message;
    }

    function setMapMessage(message) {
      mapMessage.textContent = message;
      mapMessage.hidden = !message;
    }

    function resultCountMessage(count) {
      return count + ' ' + (count === 1 ? labels.resultOne : labels.resultMany);
    }

    function setActiveStore(activeStore, shouldScroll) {
      stores.forEach(function (store) {
        store.element.classList.toggle('is-active', store === activeStore);
      });

      if (!activeStore) {
        return;
      }

      if (map && activeStore.marker) {
        map.panTo({ lat: activeStore.lat, lng: activeStore.lng });
        infoWindow.setContent(createInfoContent(activeStore, labels));
        infoWindow.open(map, activeStore.marker);
      }

      if (shouldScroll) {
        activeStore.element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function updateStoreVisibility(visibleStores, origin, fallbackUsed) {
      var visibleSet = new Set(visibleStores);

      stores.forEach(function (store) {
        var isVisible = visibleSet.has(store);
        store.element.hidden = !isVisible;

        if (store.marker) {
          store.marker.setMap(isVisible && map ? map : null);
        }

        if (origin && isVisible && Number.isFinite(store.distance)) {
          store.distanceElement.textContent = store.distance.toFixed(1) + ' ' + labels.distanceLabel;
          store.distanceElement.hidden = false;
        } else {
          store.distanceElement.textContent = '';
          store.distanceElement.hidden = true;
        }
      });

      visibleStores.forEach(function (store) {
        list.appendChild(store.element);
      });

      setActiveStore(null, false);
      setStatus(fallbackUsed ? labels.nearestFallback : resultCountMessage(visibleStores.length));

      if (!map || !origin || visibleStores.length === 0) {
        return;
      }

      var bounds = new window.google.maps.LatLngBounds();
      bounds.extend(origin);
      visibleStores.forEach(function (store) {
        bounds.extend({ lat: store.lat, lng: store.lng });
      });
      map.fitBounds(bounds, 64);

      window.google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
        if (map.getZoom() > 11) {
          map.setZoom(11);
        }
      });
    }

    function setOriginMarker(origin) {
      if (!map) {
        return;
      }

      if (originMarker) {
        originMarker.setPosition(origin);
        originMarker.setMap(map);
        return;
      }

      originMarker = new window.google.maps.Marker({
        position: origin,
        map: map,
        title: labels.yourLocation,
        zIndex: 1000,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          fillColor: '#1a73e8',
          fillOpacity: 1,
          scale: 8,
          strokeColor: '#ffffff',
          strokeWeight: 3
        }
      });
    }

    function applyOrigin(origin) {
      var sortedStores = stores.map(function (store) {
        store.distance = haversineDistance(origin, { lat: store.lat, lng: store.lng });
        return store;
      }).sort(function (left, right) {
        return left.distance - right.distance;
      });
      var nearbyStores = sortedStores.filter(function (store) {
        return store.distance <= SEARCH_RADIUS_KM;
      });
      var fallbackUsed = nearbyStores.length === 0;
      var visibleStores = fallbackUsed
        ? sortedStores.slice(0, NEAREST_FALLBACK_COUNT)
        : nearbyStores;

      setOriginMarker(origin);
      updateStoreVisibility(visibleStores, origin, fallbackUsed);
    }

    function resetLocator() {
      input.value = '';
      resolvedInputValue = '';
      stores.sort(function (left, right) {
        return left.index - right.index;
      }).forEach(function (store) {
        store.distance = null;
        store.element.hidden = false;
        store.distanceElement.textContent = '';
        store.distanceElement.hidden = true;
        list.appendChild(store.element);

        if (store.marker && map) {
          store.marker.setMap(map);
        }
      });

      if (originMarker) {
        originMarker.setMap(null);
      }

      if (infoWindow) {
        infoWindow.close();
      }

      setActiveStore(null, false);
      setStatus(labels.allLocations);
      setMapMessage('');

      if (map) {
        map.setCenter(DEFAULT_CENTER);
        map.setZoom(DEFAULT_ZOOM);
      }
    }

    function applyTextFallback(query) {
      var normalizedQuery = normalizeText(query);
      var matches = stores.filter(function (store) {
        return store.searchText.indexOf(normalizedQuery) !== -1;
      });

      if (matches.length === 0) {
        setStatus(labels.searchError);
        return;
      }

      updateStoreVisibility(matches, null, false);
    }

    function searchPlaces(query) {
      if (!autocompleteService || !placesService) {
        applyTextFallback(query);
        return;
      }

      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      autocompleteService.getPlacePredictions(
        {
          input: query,
          componentRestrictions: { country: 'CA' }
        },
        function (predictions, predictionStatus) {
          if (predictionStatus !== 'OK' || !predictions || !predictions[0]) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            setStatus(labels.searchError);
            return;
          }

          placesService.getDetails(
            {
              placeId: predictions[0].place_id,
              fields: ['geometry']
            },
            function (place, placeStatus) {
              submitButton.disabled = false;
              submitButton.removeAttribute('aria-busy');

              if (
                placeStatus !== 'OK' ||
                !place ||
                !place.geometry ||
                !place.geometry.location
              ) {
                setStatus(labels.searchError);
                return;
              }

              resolvedInputValue = input.value;
              applyOrigin({
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
              });
            }
          );
        }
      );
    }

    function bindCardInteractions() {
      stores.forEach(function (store) {
        store.element.addEventListener('click', function (event) {
          if (!event.target.closest('a, button')) {
            setActiveStore(store, false);
          }
        });
        store.element.addEventListener('focusin', function () {
          setActiveStore(store, false);
        });
      });
    }

    function initializeMap() {
      map = new window.google.maps.Map(mapElement, {
        center: DEFAULT_CENTER,
        zoom: DEFAULT_ZOOM,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        gestureHandling: 'cooperative'
      });
      infoWindow = new window.google.maps.InfoWindow();
      if (
        window.google.maps.places &&
        window.google.maps.places.AutocompleteService &&
        window.google.maps.places.PlacesService
      ) {
        autocompleteService = new window.google.maps.places.AutocompleteService();
        placesService = new window.google.maps.places.PlacesService(map);
      }

      stores.forEach(function (store) {
        store.marker = new window.google.maps.Marker({
          position: { lat: store.lat, lng: store.lng },
          map: map,
          title: store.name
        });
        store.marker.addListener('click', function () {
          setActiveStore(store, true);
        });
      });

      if (window.google.maps.places && window.google.maps.places.Autocomplete) {
        autocomplete = new window.google.maps.places.Autocomplete(input, {
          componentRestrictions: { country: 'ca' },
          fields: ['formatted_address', 'geometry', 'name']
        });
        autocomplete.addListener('place_changed', function () {
          var place = autocomplete.getPlace();
          if (!place || !place.geometry || !place.geometry.location) {
            return;
          }

          resolvedInputValue = input.value;
          applyOrigin({
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          });
        });
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var query = input.value.trim();

      if (!query) {
        resetLocator();
        return;
      }

      if (resolvedInputValue === input.value) {
        return;
      }

      searchPlaces(query);
    });

    input.addEventListener('input', function () {
      if (input.value !== resolvedInputValue) {
        resolvedInputValue = '';
      }
    });

    clearButton.addEventListener('click', resetLocator);
    locationButton.addEventListener('click', function () {
      if (!navigator.geolocation) {
        setStatus(labels.locationError);
        return;
      }

      locationButton.disabled = true;
      locationButton.setAttribute('aria-busy', 'true');
      navigator.geolocation.getCurrentPosition(
        function (position) {
          locationButton.disabled = false;
          locationButton.removeAttribute('aria-busy');
          applyOrigin({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        },
        function () {
          locationButton.disabled = false;
          locationButton.removeAttribute('aria-busy');
          setStatus(labels.locationError);

          if (map) {
            map.setCenter(DEFAULT_CENTER);
            map.setZoom(DEFAULT_ZOOM);
          }
        },
        {
          enableHighAccuracy: false,
          timeout: 8000,
          maximumAge: 300000
        }
      );
    });

    bindCardInteractions();
    setStatus(labels.allLocations);
    waitForGoogleMaps(initializeMap, function () {
      setMapMessage(labels.mapUnavailable);
    });
  }

  function findLocalBusinessSchema(root) {
    var scripts = Array.prototype.slice.call(
      root.querySelectorAll('[data-store-page-content] script[type="application/ld+json"]')
    );

    for (var index = 0; index < scripts.length; index += 1) {
      try {
        var schema = JSON.parse(scripts[index].textContent);
        var types = Array.isArray(schema['@type']) ? schema['@type'] : [schema['@type']];
        if (types.indexOf('LocalBusiness') !== -1) {
          return schema;
        }
      } catch (error) {
        // Continue looking for a valid LocalBusiness object.
      }
    }

    return null;
  }

  function schemaAddress(schema) {
    var address = schema && schema.address ? schema.address : {};
    return [
      address.streetAddress,
      address.addressLocality,
      address.addressRegion,
      address.postalCode,
      address.addressCountry
    ].filter(Boolean).join(', ');
  }

  function initStorePage(root) {
    var mapElement = root.querySelector('[data-store-page-map]');
    var mapMessage = root.querySelector('[data-store-page-map-message]');
    var fallback = root.querySelector('[data-store-page-map-fallback]');
    var directionsLink = root.querySelector('[data-store-page-directions]');
    var schema = findLocalBusinessSchema(root);
    var unavailableMessage = root.dataset.mapUnavailable;

    function showFallback() {
      mapMessage.textContent = unavailableMessage;
      mapMessage.hidden = false;
      fallback.hidden = false;
    }

    if (!schema || !schema.geo) {
      showFallback();
      return;
    }

    var latitude = Number(schema.geo.latitude);
    var longitude = Number(schema.geo.longitude);
    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      showFallback();
      return;
    }

    var address = schemaAddress(schema);
    directionsLink.href =
      'https://www.google.com/maps/dir/?api=1&destination=' +
      encodeURIComponent(address || schema.name || '');

    waitForGoogleMaps(function () {
      var position = { lat: latitude, lng: longitude };
      var map = new window.google.maps.Map(mapElement, {
        center: position,
        zoom: 15,
        mapTypeControl: false,
        streetViewControl: true,
        fullscreenControl: true,
        gestureHandling: 'cooperative'
      });
      var marker = new window.google.maps.Marker({
        position: position,
        map: map,
        title: schema.name || root.dataset.storeName
      });
      var infoWindow = new window.google.maps.InfoWindow({
        content: createInfoContent(
          {
            name: schema.name || root.dataset.storeName,
            address: address,
            url: schema.url || window.location.href,
            directionsUrl: directionsLink.href
          },
          {
            viewStore: root.dataset.viewStore,
            directions: root.dataset.directions
          }
        )
      });
      marker.addListener('click', function () {
        infoWindow.open(map, marker);
      });
    }, showFallback);
  }

  function initialize() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-store-locator]'),
      initStoreLocator
    );
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-store-page]'),
      initStorePage
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
